import { RootState } from '@shared/model';

export const selectModalState = (state: RootState) => state.modal;
